import * as Sentry from '@sentry/browser'
import { Integrations } from '@sentry/tracing'

Sentry.init({
  dsn:
    'https://1eb7f5d38a884bde8773de68ad624c1b@o454356.ingest.sentry.io/5444185',
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1.0,
  release: `party-line-web@${process.env.GIT_COMMIT_HASH}`,
})
